import { FC } from "react";
import { Modal } from "@monolith-forensics/monolith-ui";

import EditInquiryForm from "../Forms/EditInquiryForm";
import type { Inquiry } from "../inquiries.types";

interface EditInquiryModalProps {
  show: boolean;
  onClose: () => void;
  onSubmit?: (result?: unknown) => void;
  onCancel?: () => void;
  defaultInfo: Inquiry;
}

export const EditInquiryModal: FC<EditInquiryModalProps> = ({
  show,
  onClose,
  onSubmit,
  onCancel,
  defaultInfo,
}) => {
  const handleSubmit = (result?: unknown) => {
    onSubmit?.(result);
    onClose();
  };

  const handleCancel = () => {
    onCancel?.();
    onClose();
  };

  return (
    <Modal open={show} onClose={handleCancel}>
      <EditInquiryForm
        width={700}
        defaultFormData={defaultInfo}
        onSubmit={handleSubmit}
        onCancel={handleCancel}
      />
    </Modal>
  );
};

export default EditInquiryModal;
